<template><section><h2>progress</h2>
<demo-block>
                  <div slot="source"><template>
  <div class="progress">
    <weui-progress :percent="progress1" @onCancel="cancel()"></weui-progress>
    <weui-progress :percent="progress2" :showCancel="false"></weui-progress>
    <weui-progress :percent="progress3" @onCancel="cancel()"></weui-progress>
    <weui-button @click="upload()" :disabled="isLoading">上传</weui-button>
  </div>
</template>


</div>
                  
                  <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;progress&quot;&gt;
    &lt;weui-progress :percent=&quot;progress1&quot; @onCancel=&quot;cancel()&quot;&gt;&lt;/weui-progress&gt;
    &lt;weui-progress :percent=&quot;progress2&quot; :showCancel=&quot;false&quot;&gt;&lt;/weui-progress&gt;
    &lt;weui-progress :percent=&quot;progress3&quot; @onCancel=&quot;cancel()&quot;&gt;&lt;/weui-progress&gt;
    &lt;weui-button @click=&quot;upload()&quot; :disabled=&quot;isLoading&quot;&gt;上传&lt;/weui-button&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
  export default {
    data() {
      return {
        isLoading: false,
        progress1: 10,
        progress2: 30,
        progress3: 50
      }
    },
    methods: {
      cancel: function() {
        console.log('cancel');
      },
      upload: function() {
        this.isLoading = true
        this.progress1 = 10
        this.progress2 = 30
        this.progress3 = 50
        let complete = 0
        const uploadInterval = setInterval(() =&gt; {
          let progress1 = this.progress1 + 1
          let progress2 = this.progress2 + 1
          let progress3 = this.progress3 + 1
          if(progress1 &lt;= 100) {
            if(progress1 === 100) {
              complete++
            }

            this.progress1 = progress1
          }
          if(progress2 &lt;= 100) {
            if(progress2 === 100) {
              complete++
            }

            this.progress2 = progress2
          }
          if(progress3 &lt;= 100) {
            if(progress3 === 100) {
              complete++
            }

            this.progress3 = progress3
          }

          if(complete &gt;= 3) {
            this.isLoading = false
            clearInterval(uploadInterval)
          }
        }, 20)
      }
    }
  }
&lt;/script&gt;
&lt;style&gt;
  .progress {
    background-color: var(--weui-BG-2);
    padding: 10px;
  }
  .weui-progress {
    margin-bottom: 10px;
  }
  .weui-progress:last-child {
    margin-bottom: 0;
  }
&lt;/style&gt;
</code></pre></template></demo-block><h2>Attributes</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>percent</td>
<td>进度百分比</td>
<td>number</td>
<td>0-100</td>
<td>0</td>
</tr>
<tr>
<td>showCancel</td>
<td>是否显示取消按钮</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<h2>Event</h2>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>onCancel</td>
<td>取消事件回调</td>
<td>function()</td>
</tr>
</tbody>
</table>
</section></template>
<style>
  .progress {
    background-color: var(--weui-BG-2);
    padding: 10px;
  }
  .weui-progress {
    margin-bottom: 10px;
  }
  .weui-progress:last-child {
    margin-bottom: 0;
  }
</style>
<script>
  export default {
    data() {
      return {
        isLoading: false,
        progress1: 10,
        progress2: 30,
        progress3: 50
      }
    },
    methods: {
      cancel: function() {
        console.log('cancel');
      },
      upload: function() {
        this.isLoading = true
        this.progress1 = 10
        this.progress2 = 30
        this.progress3 = 50
        let complete = 0
        const uploadInterval = setInterval(() => {
          let progress1 = this.progress1 + 1
          let progress2 = this.progress2 + 1
          let progress3 = this.progress3 + 1
          if(progress1 <= 100) {
            if(progress1 === 100) {
              complete++
            }

            this.progress1 = progress1
          }
          if(progress2 <= 100) {
            if(progress2 === 100) {
              complete++
            }

            this.progress2 = progress2
          }
          if(progress3 <= 100) {
            if(progress3 === 100) {
              complete++
            }

            this.progress3 = progress3
          }

          if(complete >= 3) {
            this.isLoading = false
            clearInterval(uploadInterval)
          }
        }, 20)
      }
    }
  }
</script>